export const elementsIsOverlapping = (el1, el2) => {
  if (!el1 || !el2) return false
  const domRect1 = el1.getBoundingClientRect();
  const domRect2 = el2.getBoundingClientRect();

  return !(
    domRect1.top > domRect2.bottom ||
    domRect1.right < domRect2.left ||
    domRect1.bottom < domRect2.top ||
    domRect1.left > domRect2.right
  );
}

export const extractContent = (s) => {
  if (process.client) {
    const span = document.createElement('div');
    span.innerHTML = s;
    return span.textContent || span.innerText;
  }
  return ""
};

export const removeTagsFromText = (text) => {
  const regex = /(<([^>]+)>)/ig
  return text.replace(regex, "");
}

export const pickRandomItem = (items) => {
  if (!items || !items.length) {
    return undefined
  }
  return items[Math.floor(Math.random() * items.length)]
}

export const indexOfMax = (arr) => {
  if (arr.length === 0) {
    return -1;
  }

  let max = arr[0];
  let maxIndex = 0;

  for (let i = 1; i < arr.length; i++) {
    if (arr[i] > max) {
      maxIndex = i;
      max = arr[i];
    }
  }

  return maxIndex;
}

export const indexOfMin = (arr) => {
  if (arr.length === 0) {
    return -1;
  }

  let min = arr[0];
  let minIndex = 0;

  for (let i = 1; i < arr.length; i++) {
    if (min > arr[i]) {
      minIndex = i;
      min = arr[i];
    }
  }

  return minIndex;
}

export function isValidHttpUrl(string) {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
}

export const truncateString = (inputString) => {
  // Проверяем, есть ли точки или точки с запятой в первых 250 символах строки
  const punctuationIndices = [...inputString.slice(0, 250).matchAll(new RegExp(/[.;]/, 'gi'))].map(a => a.index);

  if (punctuationIndices.length) {
    // Обрезаем строку по последней найденной точке или точке с запятой
    return inputString.slice(0, punctuationIndices[punctuationIndices.length - 1] + 1);
  } else {
    // Если символы не найдены, возвращаем исходную строку
    return inputString;
  }
}


/**
 * Делает цвет более прозрачным
 * @param hexColor Цвет в формате #FFFFFF
 * @param alpha Значение прозразности
 * @return {string}
 */
export const colorToTransparantize = (hexColor, alpha = 0.5) => {
  if (!hexColor) return

  return "rgba(" +
    parseInt(hexColor.slice(1, 3), 16) + ", " +
    parseInt(hexColor.slice(3, 5), 16) + ", " +
    parseInt(hexColor.slice(5, 7), 16) + ", " +
    alpha + ")";
}

/**
 * Делает цвет более осветленным/затемненным
 * @param hexColor Цвет в формате #FFFFFF
 * @param alpha Значение прозразности
 * @return {string}
 */
export const adjustColorBrightness = (color, factor) => {
  if (!color) return null;

  // HEX в RGB
  function hexToRgb(hex) {
    hex = hex.replace(/^#/, '');
    if (hex.length === 3) {
      hex = hex.split('').map(c => c + c).join('');
    }
    const bigint = parseInt(hex, 16);
    return {
      r: (bigint >> 16) & 255, // старшие 8 бит → красный
      g: (bigint >> 8) & 255,  // средние 8 бит → зелёный
      b: bigint & 255,         // младшие 8 бит → синий
      a: 1
    };
  }

  // RGB в HEX
  function rgbToHex(r, g, b) {
    return (
      '#' +
      [r, g, b]
        .map(x => {
          const hex = x.toString(16);
          return hex.length === 1 ? '0' + hex : hex;
        })
        .join('')
    );
  }

  // разбор rgba/rgb строки
  function parseRgba(str) {
    const match = str.match(
      /rgba?\s*\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})(?:\s*,\s*([\d.]+))?\s*\)/
    );
    if (!match) return null;
    return {
      r: parseInt(match[1], 10),
      g: parseInt(match[2], 10),
      b: parseInt(match[3], 10),
      a: match[4] !== undefined ? parseFloat(match[4]) : 1
    };
  }

  // преобразование в строку
  function toRgbString({ r, g, b }) {
    return `rgb(${r}, ${g}, ${b})`;
  }
  function toRgbaString({ r, g, b, a }) {
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }

  let rgb, format;

  if (color.startsWith('#')) {
    rgb = hexToRgb(color);
    format = 'hex';
  } else if (color.startsWith('rgba')) {
    rgb = parseRgba(color);
    format = 'rgba';
  } else if (color.startsWith('rgb')) {
    rgb = parseRgba(color);
    format = 'rgb';
  } else {
    return null;
  }

  // применяем фактор
  let newR = Math.min(255, Math.max(0, Math.round(rgb.r * factor)));
  let newG = Math.min(255, Math.max(0, Math.round(rgb.g * factor)));
  let newB = Math.min(255, Math.max(0, Math.round(rgb.b * factor)));

  // возвращаем в том же формате
  if (format === 'hex') {
    return rgbToHex(newR, newG, newB);
  } else if (format === 'rgb') {
    return toRgbString({ r: newR, g: newG, b: newB });
  } else {
    return toRgbaString({ r: newR, g: newG, b: newB, a: rgb.a });
  }
}

/**
 * Склоняет существительные в зависимости от числа
 * @param {number} number количество объектов склонения
 * @param {Array} words слово которое склоняем
 * @return {string}
 * @example
 * // returns "дня"
 * declensionOfNouns(2, ["день", "дня", "дней"])
 */
export const declensionOfNouns = (number, words) => words[(number % 100 > 4 && number % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(number % 10 < 5) ? number % 10 : 5]];

/**
 * Преобразует одномерный массив в двумерный заданного количества
 * @param {itemsCount} number количество массивов, которое нужно получить
 * @param {Array} arr массив, который нужно преобразовать
 * @return {string}
 * @example
 * // returns [[1,2,3], [4,5,6], [7]]
 * splitArray([1,2,3,4,5,6,7], 3)
 */
export const splitArray = (arr, itemsCount) => {
  const splited = []
  for (let i = 0; i < arr.length; i += itemsCount) {
    splited.push(arr.slice(i, i + itemsCount))
  }
  return splited
}

export const trackHit = (to, title, from) => {
  try {
    if (process.env.isStaging) return

    if (process.client) {
      ym(93736397, 'hit', to, {
        title: title,
        referer: from
      });
    }
  } catch (e) {

  }
}

export const hexToRgb = (hexColor) => {
  // Убираем символ # из HEX цвета
  const hex = hexColor.substring(1);

  // Разбиваем HEX на составляющие красного, зеленого и синего каналов
  const red = parseInt(hex.substring(0, 2), 16);
  const green = parseInt(hex.substring(2, 4), 16);
  const blue = parseInt(hex.substring(4, 6), 16);

  // Возвращаем RGB цвет в виде строки
  return `${red}, ${green}, ${blue}`;
}

export const rgbToHex = (red, green, blue) => {
  // Убеждаемся, что значения каналов находятся в пределах 0–255
  const r = Math.max(0, Math.min(255, red)).toString(16).padStart(2, '0');
  const g = Math.max(0, Math.min(255, green)).toString(16).padStart(2, '0');
  const b = Math.max(0, Math.min(255, blue)).toString(16).padStart(2, '0');

  return `#${r}${g}${b}`;
}

export const rgbaToHex = (red, green, blue, alpha = 1) => {
  // Убеждаемся, что значения каналов находятся в пределах 0–255
  const r = Math.max(0, Math.min(255, red)).toString(16).padStart(2, '0');
  const g = Math.max(0, Math.min(255, green)).toString(16).padStart(2, '0');
  const b = Math.max(0, Math.min(255, blue)).toString(16).padStart(2, '0');

  // Преобразуем альфа-канал (0–1) в диапазон 00–FF
  const a = Math.round(Math.max(0, Math.min(1, alpha)) * 255)
    .toString(16)
    .padStart(2, '0')
    .toUpperCase();

  // Собираем HEX цвет с альфа-каналом
  return `#${r}${g}${b}${a}`;
};

/**
 * Возвращает стили для маски.
 * Для `22_maska_kvadrat-skruglenny` используем border-radius в px (не масштабируется),
 * а `mask-image` отключаем.
 */
export const buildMaskStyle = (mask, { radiusPx = 15 } = {}) => {
  if (!mask) return {}

  if (mask === '22_maska_kvadrat-skruglenny') {
    return {
      'mask-image': 'none',
      borderRadius: `${radiusPx}px`,
      overflow: 'hidden',
    }
  }

  return { 'mask-image': `url(#${mask})` }
}
